import React from "react"
import { Link, graphql } from "gatsby"
import { motion } from "framer-motion"
import Layout from "../components/layout"
import Project from "../components/Project/Project"
import SEO from "../components/seo"
import RecommendedPosts from "../components/Blog/RecommendedPosts"
import {ArrowDown} from "../components/icons/arrow-down-icon"

function FadeInWhenVisible({ children }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  )
}

const projectPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const siteUrl = data.site.siteMetadata.canonicalUrl
  const allProjects = data.projects.edges
  return (
    <Layout>
      <SEO 
      title={`The Projects of ${siteTitle}`} 
      description="Check out my latest projects or things I've been working on. Hit me up if you want to collaborate, add improvement or just talk about ideas." 
      keywords={["projects", "project", "danniel", "danniel hansel", "daniel", "danielhansel", "React", "JavaScript", "Gatsby", "AWS", "Tailwind CSS"]}
      url={`${siteUrl}${location.pathname}`} />
      <div className="flex justify-center items-center bg-gradient-to-br from-purple-200 via-indigo-300 to-teal-300 dark:from-gray-700 dark:via-gray-900 dark:to-black background-animate mb-20">
        <div className="overflow-x-hidden">
          <div className="container mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 place-items-center gap-4 h-screen">
              <div className="">
                <div className="block lg:hidden relative w-full max-w-lg">
                  <div className="absolute top-0 -left-4 w-64 h-64 bg-purple-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob "></div>
                  <div className="absolute top-0 -right-4 w-64 h-64 bg-yellow-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                  <div className="absolute -bottom-8 left-20 w-64 h-64 bg-pink-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
                  <div className="mx-auto rounded-full relative w-60 h-60 hover:scale-125 hover:z-10 transform ease-in-out transition duration-500 ">
                    {/* <img src={frontmatter.profileUrl} className="object-cover md:object-scale-down h-full w-full rounded-full ring ring-accent ring-offset-4 ring-offset-transparent" alt={frontmatter.author} /> */}
                  </div>
                </div>
                <header className="px-4">
                  <FadeInWhenVisible>
                    <h1 className="font-body2 mt-20 lg:mt-0 font-medium text-3xl lg:text-5xl text-quarternary text-start">
                      Projects
                    </h1>
                    <h2 className="font-medium text-3xl lg:text-5xl text-secondary-text text-start mt-6">
                      Check out my latest projects or things I've been working on.
                    </h2>
                  </FadeInWhenVisible>
                  <div 
                    className="hidden md:flex items-center justify-start text-secondary-text hover:text-quarternary pt-12"
                    // onClick={() => { navigate("/#about")}}
                    >
                      <Link to="#allProjects" aria-label="read more about Danniel Hansel">
                        <button class="flex flex-cols-2 space-x-6 items-center justify-center">
                          <ArrowDown />
                          <span className="font-body2 relative text-2xl font-semibold leading-relaxed tracking-tight ">See my projects</span>
                        </button>
                      </Link>
                      
                  </div>
                </header>
              </div>
              <div className="hidden lg:block ">
                <div className="relative w-full max-w-lg">
                    <div className="absolute top-0 -left-20 w-96 h-96 bg-purple-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob "></div>
                    <div className="absolute top-0 -right-4 w-96 h-96 bg-yellow-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                    <div className="absolute -bottom-8 left-20 w-96 h-96 bg-pink-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
                    <div className="mx-auto rounded-full relative w-80 h-80 hover:scale-125 hover:z-10 transform ease-in-out transition duration-500 ">
                    {/* <img src={frontmatter.profileUrl} className="object-cover h-full w-full rounded-full ring ring-accent ring-offset-4 ring-offset-transparent"alt={frontmatter.author} /> */}
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <section id="allProjects" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 scroll-mt-32 lg:scroll-mt-36">
          {allProjects.map((project, id) => {
            return <Project content={project.node} />
          })}
        </section>
        <div className="mt-48 lg:mt-64">
          <RecommendedPosts content={data.related.edges} />
        </div>
      </div>
    </Layout>
  )
}
export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        canonicalUrl
        image
        author {
          name
        }
        organization {
          name
          url
          logo
        }
        social {
          twitter
        }
      }
    }
    projects: allMdx(
      filter: {
        fileAbsolutePath: { regex: "/content/project/" }
        frontmatter: { visible: { eq: "true" } }
      }
      sort: { fields: frontmatter___position, order: ASC }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          body
          excerpt
          frontmatter {
            title
            visible
            tags
            position
            live
            github
            external
            category
            thumbnailUrl
          }
        }
      }
    }
    related: allMdx(
      limit: 3
      filter: {
        fileAbsolutePath: { regex: "/content/blog/" }
        frontmatter: { published: { eq: true }, featured: { eq: true } }
      }
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            slug
            title
            author
            bannerUrl
            bannerCredit
            slug
            tags
            description
            date(formatString: "Do MMM YYYY")
          }
          excerpt
          id
          body
          timeToRead
        }
      }
    }
  }
`
export default projectPage
